module.exports = __webpack_public_path__ + "static/img/08.fd48ab51.png";